import { Spinner, RainbowThemeContainer } from "react-rainbow-components";
const theme = {
	rainbow: {
		palette: {
			brand: "#002E6E"
		}
	}
};
const LoadingSpinner = ({ height = 400, size = "large", spinnerStyle = {}, className }) => {
	return (
		<>
			<div className={`spinner d-flex justify-content-center align-items-center ${className || ""}`}>
				<RainbowThemeContainer theme={theme}>
					<Spinner style={{ zIndex: 99, ...spinnerStyle }} size={size} type="arc" variant="brand" />
				</RainbowThemeContainer>
			</div>
			<style>{`
				.spinner {
					height: ${height}px;
				}
				.spinner:before {
					border-top-color: transparent;
				}
			`}</style>
		</>
	);
};

export default LoadingSpinner;
